export enum ReduxActionType {
  LOGIN = 500100, // 登錄
  USER, // 用戶信息
  HISTORY // 页面访问记录
}
